import { render } from "./Persons.vue?vue&type=template&id=5d8f3014&scoped=true&ts=true"
import script from "./Persons.vue?vue&type=script&lang=ts"
export * from "./Persons.vue?vue&type=script&lang=ts"

import "./Persons.vue?vue&type=style&index=0&id=5d8f3014&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8f3014"]])

export default __exports__